if (!customElements.get('epl-certificate')) {
  customElements.define(
    'epl-certificate',
    class EplCertificate extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.codeInput = this.querySelector('#EplCertificateForm-code');
        this.errorContainer = this.querySelector('#EplCertificateForm-error');
        this.errorMessage = this.querySelector('.epl-certificate__error-message');
        this.submitButton = this.querySelector('button[type="submit"]');
        this.buttonText = this.querySelector('.epl-certificate__button-text');
        this.buttonLoading = this.querySelector('.epl-certificate__button-loading');

        // Сервис certificate.epldiamond.com собирает PDF по данным epldiamond.ru
        this.serviceUrl = (this.dataset.serviceUrl || 'https://certificate.epldiamond.com').replace(/\/+$/, '');

        this.form.addEventListener('submit', this.onSubmit.bind(this));
        this.codeInput.addEventListener('input', this.onInput.bind(this));

        // QR и короткая ссылка из сертификата ведут сюда с ?code=XXXXXX
        const codeFromUrl = new URLSearchParams(window.location.search).get('code');
        if (codeFromUrl && !this.codeInput.value) {
          this.codeInput.value = codeFromUrl.trim();
        }
      }

      errorFor(status) {
        if (status === 404) return this.dataset.errorNotFound;
        if (status === 429) return this.dataset.errorRateLimit;
        return this.dataset.errorDownload;
      }

      onInput() {
        this.hideError();
      }

      async onSubmit(event) {
        event.preventDefault();

        const code = this.codeInput.value.trim();

        if (!code) {
          this.showError();
          this.codeInput.focus();
          return;
        }

        this.hideError();
        this.setLoading(true);

        try {
          const response = await fetch(`${this.serviceUrl}/pdf?code=${encodeURIComponent(code)}`);

          if (!response.ok) {
            this.showError(this.errorFor(response.status) || this.dataset.errorDownload || 'Download failed. Please try again.');
            return;
          }

          const blob = await response.blob();

          if (blob.size < 500) {
            throw new Error('Invalid response');
          }

          const pdfBlob = new Blob([blob], { type: 'application/pdf' });
          const blobUrl = URL.createObjectURL(pdfBlob);
          const link = document.createElement('a');
          link.href = blobUrl;
          link.download = `EPL_Certificate_${code}.pdf`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          setTimeout(() => URL.revokeObjectURL(blobUrl), 100);
        } catch (error) {
          this.showError(this.dataset.errorDownload || 'Download failed. Please try again.');
        } finally {
          this.setLoading(false);
        }
      }

      showError(message) {
        if (message && this.errorMessage) {
          this.errorMessage.textContent = message;
        }
        this.errorContainer.hidden = false;
        this.codeInput.setAttribute('aria-invalid', 'true');
        this.codeInput.setAttribute('aria-describedby', 'EplCertificateForm-error');
      }

      hideError() {
        this.errorContainer.hidden = true;
        this.codeInput.removeAttribute('aria-invalid');
        this.codeInput.removeAttribute('aria-describedby');
      }

      setLoading(isLoading) {
        this.submitButton.disabled = isLoading;
        this.buttonText.hidden = isLoading;
        this.buttonLoading.hidden = !isLoading;
      }
    }
  );
}
